import { Phone, Email } from "@mui/icons-material";
import Linkedin_icon from "@/assets/icons/contacts/linkedin.svg?react";
import Facebook_icon from "@/assets/icons/contacts/facebook.svg?react";
import Instagrem from "@/assets/icons/contacts/insta.svg?react";
import Google from "@/assets/icons/contacts/googleLink.svg?react";

export const SUPPORT_EMAIL = "support@trackmategps.com";
export const SALES_EMAIL = "support@trackmategps.com";
export const PHONE = { value: "+17188784056", label: "+1 718-878-4056" };

export const contacts = [
  { type: "phone", Icon: Phone, label: PHONE.label, value: PHONE.value },
  { type: "email", Icon: Email, label: SUPPORT_EMAIL, value: SUPPORT_EMAIL },
];

export const workingHours = [
  { value: "Mon - Th: 9:00 am-5:00 pm EST" },
  { value: "Friday: 9:00 am-4:00 pm EST" },
];

export const socials = [
  { Icon: Linkedin_icon, href: "https://www.linkedin.com/company/trackmategps/", label: "Linkedin" },
  { Icon: Facebook_icon, href: "https://www.facebook.com/TrackmateGPSOfficial", label: "Facebook" },
  { Icon: Google, href: "https://maps.app.goo.gl/Zin6soCxE6c8a98k8", label: "Google" },
  { Icon: Instagrem, href: "https://www.instagram.com/trackmate.gps/", label: "Instagram" },
];

export const faqContacts = [
  {
    title: "Support",
    subtitle: "Our friendly team is here to help.",
    label: SUPPORT_EMAIL,
    value: SUPPORT_EMAIL,
    type: "email",
  },
  {
    title: "Sales",
    subtitle: "Questions or queries? Get in touch!",
    label: SALES_EMAIL,
    value: SALES_EMAIL,
    type: "email",
  },
  {
    title: "Phone",
    subtitle: "Mon-Th from 9am to 5pm Friday: 9am to 4pm",
    label: PHONE.label,
    value: PHONE.value,
    type: "phone",
  },
];
